import EcoNavProduct, { EcoNavProductItemProps, EcoNavProductProps } from 'eco-design/sections/eco-nav-product';

import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { FC, useEffect, useState } from 'react';
import { oceanProConsultationUrl } from '../../config/pageConfig';
import gtm from '@/utils/gtm';

interface NavProps {
    theme?: 'black' | 'white';
}

enum TabsEnum {
    Overview = '/ocean-pro-home-solar-battery',
    FAQ = '/ocean-pro-home-solar-battery/faq',
    Comparison = 'Comparison',
}

const Nav: FC<NavProps> = (props) => {
    const { theme = 'black' } = props;
    const { useLang, useRouter } = useGlobal();
    const router = useRouter();
    const [defaultTabActiveKey, setDefaultTabActiveKey] = useState(router?.pathname || '');

    const { t } = useLang('OceanProHomeSolarBattery');

    const dataA: EcoNavProductProps = {
        tabItems: [
            {
                value: TabsEnum.Overview,
                label: t(`nav_overview`),
                // href: '/ocean-pro-home-solar-battery',
            },
            // {
            //     value: 'EcoFlow APP',
            //     label: t(`nav_ecoFlow`),
            //     href: `https://homebattery.ecoflow.com/eu/hems/ecoflow-app`,
            // },
            {
                value: TabsEnum.FAQ,
                label: t(`nav_FAQ`),
                // href: `/ocean-pro-home-solar-battery/faq`,
            },
            {
                value: TabsEnum.Comparison,
                label: t(`nav_Comparison`),

                // href: `/ocean-pro-home-solar-battery/faq`,
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: t(`nav_schedule`),
                href: oceanProConsultationUrl,
                dataLayer: {
                    event: 'uaEvent',
                    event_name: 'product_navigation',
                    navigation_name: t(`nav_schedule`),
                    product_name: t(`nav_logo_text`),
                },
            },
        ],
    };

    const handleTabChange = (item: EcoNavProductItemProps) => {
        switch (item.value) {
            case TabsEnum.Overview:
                if (defaultTabActiveKey === TabsEnum.FAQ) {
                    router.push(TabsEnum.Overview);
                } else {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                }
                break;
            case TabsEnum.FAQ:
                router.push(TabsEnum.FAQ);
                break;
            case TabsEnum.Comparison:
                if (defaultTabActiveKey === TabsEnum.FAQ) {
                    router.push('/ocean-pro-home-solar-battery#Solutions');
                } else {
                    document.getElementById('Solutions')?.scrollIntoView();
                }
        }
    };

    useEffect(() => {
        if (router.asPath.includes('#Solutions')) {
            setDefaultTabActiveKey(TabsEnum.Comparison);
            document.getElementById('Solutions')?.scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
                history.replaceState(null, '', router.pathname);
            }, 500);
        }
    }, [router.asPath]);

    return (
        <div className={styles.comp}>
            <EcoNavProduct
                productItems={[
                    {
                        value: 'logo',
                        label: t(`nav_logo_text`),
                        href: '/ocean-pro-home-solar-battery',
                    },
                ]}
                {...dataA}
                defaultTabActiveKey={defaultTabActiveKey}
                theme={theme}
                onTabChange={handleTabChange}
                onBuyChange={(item) => {
                    gtm.push(item.dataLayer);
                }}
            />
        </div>
    );
};

export default Nav;
